import { TriggerExecutorGroup } from './TriggerExecutorGroup';
import { TriggerGroup } from './InterfaceTriggerGroup';
import { widgetTrigger } from './widgetTriggerEnum';

export class TriggerExecutor {
    executor: TriggerExecutorGroup;

    constructor(nodeId = '') {
        this.executor = new TriggerExecutorGroup(nodeId);
    }

    setupOpenTriggers(triggerGroups: TriggerGroup[]) {
        const promises = triggerGroups
            .filter((triggerGroup) => triggerGroup.type === widgetTrigger.OPEN)
            .map((group) => this.executor.setupTriggers(group, widgetTrigger.OPEN)
            );
        return Promise.race(promises);
    }

    setupCloseTriggers(triggerGroups: TriggerGroup[]) {
        const promises = triggerGroups
            .filter((triggerGroup) => triggerGroup.type === widgetTrigger.CLOSE)
            .map((group) => this.executor.setupTriggers(group, widgetTrigger.CLOSE)
            );
        return Promise.race(promises);
    }
}